<template>
	<AppModal
		v-bind="$attrs"
		class="contact-modal modal--transparent"
		content-transition="vfm-slide-down"
	>
		<div class="contact-modal__content">
			<h2 v-html="$t(title)" class="contact-modal__title title--style3"></h2>

			<p class="contact-modal__desc">
				{{ $t(desc) }}
			</p>

			<button
				class="btn btn--default contact-modal__button"
				@click="$vfm.close($attrs['modal-id'])"
			>
				{{ $t(buttonText) }}
			</button>
		</div>
	</AppModal>
</template>

<script>
import AppModal from '@/components/landing/AppModal.vue'
import { mapState } from 'pinia'
import { useQuestionsStore } from '@/stores/landing/questions.js'

export default {
	name: 'ContactModal',
	components: {
		AppModal
	},
	computed: {
		...mapState(useQuestionsStore, {
			title: 'title',
			desc: 'desc',
			buttonText: 'buttonText'
		})
	}
}
</script>
